(function() {
  var cleaning = false;
  var lastBundleCount = null;

  function checkBundleIntegrity() {
    if (cleaning) return;
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var bundleItems = cart.items.filter(function(item) {
          return item.properties && item.properties._bundle === 'Foundry Kit';
        });

        if (lastBundleCount === null) {
          lastBundleCount = bundleItems.length;
          return;
        }

        if (bundleItems.length === 0) {
          lastBundleCount = 0;
          return;
        }

        if (bundleItems.length < lastBundleCount) {
          cleaning = true;
          var updates = {};
          bundleItems.forEach(function(item) { updates[item.key] = 0; });

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function() {
            lastBundleCount = 0;
            cleaning = false;
            if (window.location.pathname === '/cart') {
              window.location.reload();
            }
          }).catch(function() {
            cleaning = false;
          });
          return;
        }

        lastBundleCount = bundleItems.length;
      });
  }

  checkBundleIntegrity();

  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var result = origFetch.apply(this, arguments);
    if (!cleaning && typeof url === 'string' &&
        (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/add') !== -1)) {
      result.then(function() {
        setTimeout(checkBundleIntegrity, 500);
      });
    }
    return result;
  };

  if (typeof XMLHttpRequest !== 'undefined') {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (!cleaning && typeof url === 'string' &&
          (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
        this.addEventListener('load', function() {
          setTimeout(checkBundleIntegrity, 500);
        });
      }
      return origOpen.apply(this, arguments);
    };
  }
})();
